import get from 'lodash/get';

export default function getTunedGuideId(guideItem, audioClipId, topicGuideId) {
  return audioClipId || topicGuideId || get(guideItem, 'actions.play.guideId');
}
